import styled from '@emotion/styled';

export const VehicleInfo = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;

	border-bottom: 1px solid ${({ theme }) => theme.colors.gray5};
	background: #fff;

	width: 100%;
	min-height: 70px;
	padding: 16px 20px;

	position: relative;
	z-index: 2;

	@media ${({ theme }) => theme.medias.desktop} {
		padding: 13px 16px;
		min-height: auto;
	}
`;

export const VehicleContent = styled.div`
	display: flex;
	width: 90%;

	@media ${({ theme }) => theme.medias.desktop} {
		width: auto;
	}
`;

export const VehicleImage = styled.img`
	width: 32px;
	height: 32px;

	border-radius: 4px;
	margin-right: 16px;

	@media ${({ theme }) => theme.medias.desktop} {
		width: 28px;
		height: 28px;
	}
`;

export const VehicleDetails = styled.p<{ nowrap?: boolean }>`
	font-size: 10px;
	color: ${({ theme }) => theme.colors.gray2};

	@media ${({ theme }) => theme.medias.phone} {
		font-size: 12px;

		${props =>
			props.nowrap &&
			`
				width: 75%;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			`};
	}
`;

export const VehicleLink = styled.a`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;

	svg {
		width: 24px;
		height: 24px;
	}
	@media ${({ theme }) => theme.medias.desktop} {
		font-size: 12px;
		font-weight: 700;
		color: #696977;

		svg {
			width: 16px;
			height: 16px;
			margin-right: 6px;

			path {
				fill: #696977;
			}
		}
	}
`;
